import { motion } from "framer-motion";
import moment from "moment";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";

const ClaimProviderMedicalDetails = () => {
  const { viewClaimInfo } = useSelector((state) => state.claim);

  const preauthMedicalDetails = viewClaimInfo?.payload_json?.sup_info || {};

  const medicalDetailsInfo = Object.values(preauthMedicalDetails);

  const chiefComplaint =
    medicalDetailsInfo?.find((item) => item?.chfcmp)?.chfcmp?.code || "";
  const onset = medicalDetailsInfo?.find((item) => item?.aspcnd)?.aspcnd || "";

  const significantsigns = viewClaimInfo?.other_fields?.sgnfcntsign || "";
  const otherconditions = viewClaimInfo?.other_fields?.othrconditions || "";
  const clinicaldata = viewClaimInfo?.other_fields?.clncldata || "";
  const treatmentplan =
    medicalDetailsInfo?.find((item) => item?.trtpln)?.trtpln || "";
  const patienthistory =
    medicalDetailsInfo?.find((item) => item?.pathistry)?.pathistry || "";
  const physicalexamination =
    medicalDetailsInfo?.find((item) => item?.phyexmn)?.phyexmn || "";
  const historypresentillness =
    medicalDetailsInfo?.find((item) => item?.histrypreill)?.histrypreill || "";


  const missingtooth = viewClaimInfo?.provider_request?.medical_details?.missingtooth
  const conditionOnset = viewClaimInfo?.provider_request?.medical_details

  return (
    <motion.div
      style={{ border: "2px solid #d9f8eb" }}
      className="rounded p-3 position-relative mt-3 mb-3"
      initial={{ opacity: 0, y: 50 }} // Starts faded out and moved down
      animate={{ opacity: 1, y: 0 }} // Fades in and moves to place
      exit={{ opacity: 0, y: 50 }} // Optional: for exit animation
      transition={{ duration: 0.5 }} // Smooth transition
    >
      {/* Floating Badge Header */}
      <div className="position-absolute top-0 start-40 translate-middle-y px-2 d-none d-md-block">
        <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
          <span className="fs-11">Medical Details</span>
        </span>
      </div>
      <Row>
        <Col xs={12}>
          {/* Chief Complaint */}
          <Row>
            <Col xs={12} md={3}>
              <span className="fs-10 fw-bold">Chief Complaint</span>
            </Col>
            <Col xs={12} md={9}>
              <span className="fs-10 fw-normal text-800">{chiefComplaint}</span>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col xs={12} md={3}>
              <span className="fs-10 fw-bold">
                Aspects Of Condition (Onset)
              </span>
            </Col>
            <Col xs={12} md={9}>
              <span className="fs-10 fw-normal text-800">
                {conditionOnset?.onset ? `(${conditionOnset?.onset}) - ` : ""}{" "}
                {conditionOnset?.onsetdate ? moment(conditionOnset?.onsetdate).format("DD-MM-YYYY") : ""}
              </span>
            </Col>
          </Row>
          <hr />

          {/* Significant Signs */}
          <Row>
            <Col xs={12} md={3}>
              <span className="fs-10 fw-bold">Significant Signs</span>
            </Col>
            <Col xs={12} md={9}>
              <span className="fs-10 fw-normal text-800">
                {significantsigns}
              </span>
            </Col>
          </Row>
          <hr />

          {/* Other Conditions */}
          <Row>
            <Col xs={12} md={3}>
              <span className="fs-10 fw-bold">Other Conditions</span>
            </Col>
            <Col xs={12} md={9}>
              <span className="fs-10 fw-normal text-800">
                {otherconditions}
              </span>
            </Col>
          </Row>
          <hr />

          {/* Clinical Data */}
          <Row>
            <Col xs={12} md={3}>
              <span className="fs-10 fw-bold">Clinical Data</span>
            </Col>
            <Col xs={12} md={9}>
              <span className="fs-10 fw-normal text-800">{clinicaldata}</span>
            </Col>
          </Row>
          <hr />

          {/* Treatment Plan */}
          {missingtooth?.tooth_no && (
            <>
              <Row>
                <Col xs={12} md={3}>
                  <span className="fs-10 fw-bold">Missing Tooth</span>
                </Col>
                <Col xs={12} md={9}>
                  <Row className="fs-10 fw-normal text-800">
                    <Col xs={4}>Number : {missingtooth?.tooth_no}</Col>
                    <Col xs={4}>
                      Date :{" "}
                      {missingtooth?.date
                        ? moment(missingtooth?.date).format("DD-MM-YYYY")
                        : ""}
                    </Col>
                    <Col xs={4}>Reason: {missingtooth?.desc}</Col>
                  </Row>
                </Col>
              </Row>
              <hr />
            </>
          )}
          <Row>
            <Col xs={12} md={3}>
              <span className="fs-10 fw-bold">Treatment Plan</span>
            </Col>
            <Col xs={12} md={9}>
              <span className="fs-10 fw-normal text-800">{treatmentplan}</span>
            </Col>
          </Row>
          <hr />

          {/* Patient History */}
          <Row>
            <Col xs={12} md={3}>
              <span className="fs-10 fw-bold">Patient History</span>
            </Col>
            <Col xs={12} md={9}>
              <span className="fs-10 fw-normal text-800">{patienthistory}</span>
            </Col>
          </Row>
          <hr />

          {/* Physical Examination */}
          <Row>
            <Col xs={12} md={3}>
              <span className="fs-10 fw-bold">Physical Examination</span>
            </Col>
            <Col xs={12} md={9}>
              <span className="fs-10 fw-normal text-800">
                {physicalexamination}
              </span>
            </Col>
          </Row>
          <hr />

          {/* History Of Present Illness */}
          <Row>
            <Col xs={12} md={3}>
              <span className="fs-10 fw-bold">History Of Present Illness</span>
            </Col>
            <Col xs={12} md={9}>
              <span className="fs-10 fw-normal text-800">
                {historypresentillness}
              </span>
            </Col>
          </Row>
        </Col>
      </Row>
    </motion.div>
  );
};

export default ClaimProviderMedicalDetails;
